<template>
  <div>
    <el-dialog :title="dataForm.id ? 'Edit Currency' : 'Add Currency'" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" label-position="right" label-width="150px">
        <el-form-item label="Currency Code" prop="currency">
          <el-input v-model="dataForm.currency" clearable placeholder="SGD"></el-input>
        </el-form-item>
        <el-form-item label="Currency Symbol" prop="symbol">
          <el-input v-model="dataForm.symbol" clearable placeholder="S$"></el-input>
        </el-form-item>
        <el-form-item label="Basis Amount" prop="exchangeRateBasis">
          <el-select v-model="dataForm.exchangeRateBasis" clearable class="wdb100">
            <el-option label="1" :value="1"></el-option>
            <el-option label="100" :value="100"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddOrUpdate",
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: "",
        currency: "",
        symbol: "",
        exchangeRateBasis: "",
      },
      dataRule: {
        currency: [{ required: true, message: "Please enter", trigger: "submit" }],
        symbol: [{ required: true, message: "Please enter", trigger: "submit" }],
        exchangeRateBasis: [{ required: true, message: "Please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          currency: data.currency,
          symbol: data.symbol,
          exchangeRateBasis: data.exchangeRateBasis,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return await this.$http.post(`/admin/currency/${params.id}/update`, params);
      } else {
        return await this.$http.post("/admin/currency/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
